module.exports = __webpack_public_path__ + "img/agreements.aa1a51eb.svg";